import { useEffect, useRef, useState } from 'react'
import { intersection_threshold, url } from '../../base/Variables'
import { ProductCard, ProductPlaceholder } from '../index'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { LazyAxios, normalizeColorForApi } from '../../base'

function OtherProducts({ heading = '', type, color = null, setPerror, name = null, id = -1 }) {
  const [products, setProducts] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const componentRef = useRef(null)
  const cart_item_list = useSelector((state) => state.cartSlice.cart_item_list)
  const baseUrl = `${url}/api/v1/product`

  async function getOtherProducts() {
    try {
      const axios = await LazyAxios()
      const request = await axios.get(`${baseUrl}/${type}/`, {
        params : {
          color : color ? normalizeColorForApi(color) : color,
          name : name,
          // id : id
        }
      })
      console.log(request.data)
      if (request.data && request.data.data) {
        setProducts(request.data.data)
      }
      setLoading(false)
    }
    catch (error) {
      console.log(error)
      setLoading(false)
    }

  }

  console.log(color)
  function seeMore() {
    if (heading === 'Top Discount Products') {
      navigate('/p/shop/all/category/all/products/?s_b=ds-hl')
    }
    else if (heading === 'Similar Products') {
      navigate(`/product/search/?q=${name && name.trim()}&in=name`)
    }
    else if (heading === 'Similar Color Products') {
      navigate(`/product/search/?q=${color && color.trim()}&in=color`)
    }

  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        // Check if the child component is in the viewport
        if (entries[0].isIntersecting && loading) {
          getOtherProducts()
        }
      },
      {
        root: null, // default to the viewport
        threshold: intersection_threshold, // 50% of the component must be visible
      }
    );

    if (componentRef.current) {
      observer.observe(componentRef.current);
    }

    return () => {
      if (componentRef.current) {
        observer.unobserve(componentRef.current);
      }
    };
  }, [loading])


  console.log(products, loading, type)
  return (
    <div className='mt-4' ref={componentRef}>
      {
        loading ? <ProductPlaceholder /> :
          products ? <div>
            <div className='h5 mb-4'>{heading}</div>
            <div style={{ display: 'flex', gap: '30px', width: '100%', overflowX: 'scroll', scrollbarWidth: 'none' }}>
              {
                products.map((item, index) => {
                  return <div key={index}>
                    <ProductCard setPerror={setPerror} product={item} added={cart_item_list[`p${item.id}`] ? true : false} />
                  </div>
                })
              }
            </div>

            <div className='text-center'><button onClick={() => seeMore()} className='primaryButton' style={{ width: '130px' }}>See All</button></div>
            <hr className='mt-5' />
          </div> : <></>
      }
    </div>

  )
}

export default OtherProducts